import React from 'react'
import { FaPlus } from "react-icons/fa6";
import {
  MDBCol,
  MDBRow
} from "mdb-react-ui-kit";
import { PiBooksThin } from "react-icons/pi";
import { GiDiscussion } from 'react-icons/gi'
import { CiTimer } from "react-icons/ci";
import { PiStudentLight } from "react-icons/pi";
import { PiUsersThreeThin } from "react-icons/pi";


function Total_Count({ interval }) {
    
    return (
      <div className='mt-5'>
        {/* ---------------------------Mobile View------------------------- */}
        <div className='d-sm-block pb-2 pt-4 d-md-none total_count_background'>
        <div className='container'>
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" xl="8" className="text-center mobile_total_component_text">
              <h1 className="">Success Stats</h1>
              <p className=" pt-2">Get to the heart of what it takes to succeed by digging into our varied courses, many hours of instruction, happy students, seasoned teachers, and solid networks of contacts at top employers. Get involved with our vibrant group!</p>
          </MDBCol>
          </MDBRow>
          <div class="container">
          <div className='row'>
          <div class="col-6">
              <div className='text-center'>
              <h1 className="mobile_Total_num" data-val="40">40<FaPlus size="30px" color="black" /></h1>
              <p className="Total_text">Programs</p>
              </div>
          </div>
          <div class="col-6">
              <div className='text-center'>
              <h1 className="mobile_Total_num" data-val="100">100</h1>
              <p className="Total_text">Hours</p>
              </div>
          </div>
          <div class="col-6">
              <div className='text-center'>
              <h1 className="mobile_Total_num" data-val="50">50<FaPlus size="30px" color="black" /></h1>
              <p className="Total_text">Mentors</p>
              </div>
          </div>
          <div class="col-6">
              <div className='text-center'>
              <h1 className="mobile_Total_num" data-val="100">100<FaPlus size="30px" color="black" /></h1>
              <p className="Total_text">Recruiters</p>
              </div>
          </div>
          <div class="col-12">
              <div className='text-center'>
              <h1 className="mobile_Total_num" data-val="10">10K<FaPlus size="30px" color="black" /></h1>
              <p className="Total_text">Students</p>
              </div>
          </div>
          </div>
          </div>
          </div>
        </div>

        {/* ---------------------------Dasktop View------------------------- */}
        <div className='d-none d-md-block total_count_background'>
        <div className='container'>
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" xl="8" className="text-center pt-5 total_component_text">
              <h1 className="display-5">Success Stats</h1>
              <p className="px-4">Get to the heart of what it takes to succeed by digging into our varied courses, many hours of instruction, happy students, seasoned teachers, and solid networks of contacts at top employers. Get involved with our vibrant group!</p>
          </MDBCol>
          </MDBRow>
          <div class="pb-4 pt-3 container">
          <div className='row'>
          <div className='d-flex justify-content-evenly'>
          <div class="">
              <div className='text-center'>
              <PiBooksThin size="50px" color="black" />
              <h1 className="pt-2 Total_num" data-val="40">40<FaPlus size="35px" color="black" /></h1>
              <p className="Total_text">Programs</p>
              </div>
          </div>
          <div class="">
              <div className='text-center'>
              <CiTimer size="50px" color="black" />
              <h1 className="Total_num pt-2" data-val="100">100</h1>
              <p className="Total_text">Hours</p>
              </div>
          </div>
          <div class="">
              <div className='text-center'>
              <PiUsersThreeThin size="50px" color="black" />
              <h1 className="Total_num pt-2" data-val="50">50<FaPlus size="35px" color="black" /></h1>
              <p className="Total_text">Mentors</p>
              </div>
          </div>
          <div class="">
              <div className='text-center'>
              <GiDiscussion size="50px" color="black" />
              <h1 className="Total_num pt-2" data-val="100">100<FaPlus size="35px" color="black" /></h1>
              <p className="Total_text">Recruiters</p>
              </div>
          </div>
          <div class="">
              <div className='text-center'>
              <PiStudentLight size="50px" color="black" />
              <h1 className="Total_num pt-2" data-val="10">10K<FaPlus size="35px" color="black" /></h1>
              <p className="Total_text">Students</p>
              </div>
          </div>
          </div>
          </div>
          </div>
          </div>
        </div>
      </div>
    );
  }
  
  export default Total_Count;


